module.exports = __webpack_public_path__ + "img/especialista6.758f4e13.png";